import React, { useEffect, useState } from 'react';
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion';
import { Container, Row, Col } from 'react-bootstrap';
import CartService from '../services/Cart';
import ProfileService from '../services/Profile';
import SingleProduct from '../component/SingleProduct';
import DefaultImage from '../assets/images/productDefault.png'
import AlertMsg from '../component/AlertMsg';
import Loader from '../component/Loader';
import { Heart } from 'react-feather';
import WishList from'../assets/images/wishList.png'
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { addTotalCartItems } from '../redux/slices/countSlice';
import NoData from '../component/NoData';


const Wishlist = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(false);
    const [isProductData, setIsProductData] = useState([]);
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [prodInfo, setProdInfo] = useState();

    useEffect(() => {
        const wishlistFetchData = async () => {
            // const token = localStorage.getItem('access_token')
            const wishListResponse = await ProfileService.getWishlist()
            
            if (!wishListResponse.error) {
                // if(wishListResponse.length > 0){
                setIsProductData(wishListResponse.data.wishlists.wishlistProductsDetails)
                setProdInfo({canRedeem: wishListResponse.data.can_redeem, mrpLabel: wishListResponse.data.mrp_label});
                setLoading(false)
                setNoData(false)
            // }
            // else{
            //     setLoading(false)
            //     setNoData(true)
            // }
         }
            else{
                setLoading(false)
                setNoData(true)
            }
        }
        wishlistFetchData()
    }, [])
    //Add To Cart
    const handleAddCart = async (product_id, catalog_id) => {
        // const token = localStorage.getItem('access_token');
        const cartRes = await CartService.myCartItems();
        if (!cartRes.error && cartRes.data?.cart_data?.row_items) {
            const cartItems = Object.values(cartRes.data.cart_data.row_items);
            const alreadyInCart = cartItems.some(item => item.product_id == product_id);
            if (alreadyInCart) {
                toast.error('Product already present in cart');
                return;
            }
        }
        const payload = {
            product_id: product_id + '',
            quantity: '1',
            // quantity: totalCartItems,
            ip: '',
            catalog_id: catalog_id + '',
        };
        const res = await CartService.addToCart(payload);

        if (!res.error) {
            // setShowAlert(true)
            dispatch(addTotalCartItems({
                cartCount: res.data.cartCount
            }))
            toast.success(res.data.message)
            setIsLoginSuccess({ isLogin: true, text: res.data.message })
            // setTimeout(() => { setShowAlert(false) }, 3000)
            removeFromWishlist(product_id);
        }

    }
    // Removes a product from the wishlist without showing the removal toast (used after a successful Add to Cart)
    const removeFromWishlist = id => {
        if (!id) return Promise.resolve();
        const payload = {
            productId: parseInt(id),
            name: 'Default List',
            description: 'Your Default Wishlist',
            toggle: 'delete',
        };
        return CartService.addToWishlist(payload)
            .then(res => {
                if (!res.error) {
                    setIsProductData(prodList => prodList.filter(prod => prod.product_id != id));
                }
                return res;
            });
    };
    const wishlistHandler = id => {
        if(!id) return;
        // setLoading(true)
        removeFromWishlist(id)
          .then(res => {
            if (!res.error) {
              toast.success("Product removed from whishlist");
            } else {
                toast.error("Try again!");
            }
          })
          .catch(err => {
            toast.error("Try again later");
          });
      };
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Wishlist"
                currentPageName="Wishlist"
            />
            <section className='padTop50'>
            <Container>
                <Row>
                    <Col>
                        {isProductData.length==0 && !loading && <NoData title='Your wishlist is empty.' />}
                    </Col>
                </Row>
                <Row>
                    {isProductData?.map((item, index) => {
                        const { product_name, short_desc, price_in_points, product_images, product_id, dcm_catalogs_id, mrp_in_point } = item
                        const imgSrc = product_images.length > 0 ? product_images[0].product_image : DefaultImage;
                        return (
                            <Col xs={12} lg={3} key={index}>
                                <SingleProduct
                                    prodId={product_id}
                                    heart={ WishList}
                                    productName={product_name}
                                    shortDesc={short_desc}
                                    price={price_in_points}
                                    mrp_in_point={mrp_in_point}
                                    getTxt="Get within 10 days"
                                    productImage={imgSrc}
                                    onPressHeart={wishlistHandler}
                                    prodInfo={prodInfo}
                                    onClickCart={() => handleAddCart(product_id, dcm_catalogs_id)} />
                            </Col>
                        )
                    })}

                </Row>
                {/* <Row>
                    <Col>
                        <div className='productListAlert alertBoxWrap'>
                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                heading={isLoginSuccess.heading}
                                text={isLoginSuccess.text}
                            />
                            }
                        </div>
                    </Col>
                </Row> */}
            </Container>
            </section>
        </>
    );
}

export default Wishlist;
